<template>
  <div>
    <video ref="videoPlayer" class="video-js vjs-big-play-centered" />
  </div>
</template>

<script>
import videojs from 'video.js';

export default {
  name: 'VideoPlayer',
  props: {
    src: {
      type: String,
    },
    type: {
      type: String,
    },
  },
  data: () => ({
    player: null,
  }),
  mounted() {
    this.init();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
  },
  methods: {
    init() {
      const options = {
        controls: true,
        fluid: true,
        sources: [
          {
            src: this.src,
            type: this.type,
          },
        ],
      };
      this.player = videojs(this.$refs.videoPlayer, options);
    },
  },
};
</script>
